/**
 * Do not edit directly, this file was auto-generated.
 */

export const onLightSurfacePrimary = "#ffffff";
export const onLightSurfaceSecondary = "#F6F8FB";
export const onLightSurfaceActive = "#EEF0F5";
export const onLightTextPrimary = "#12151A";
export const onLightTextSecondary = "#383F4D";
export const onLightTextTertiary = "#666E7D";
export const onLightTextLink = "#2A4ECC";
export const onLightBorderSubtle = "#282d371a";
export const onLightBorderEmphasis = "#282d378a";
export const onLightBorderActive = "#2A4ECC";
export const onLightBorderActionPrimaryFallback = "transparent";
export const onLightIconPrimary = "#282D37";
export const onLightIconSecondary = "#666E7D";
export const onLightOverlay = "#282d3780";
export const onLightShadowSm = "0px 2px 4px 0px #383f4d12";
export const onLightShadowMd = "0px 6px 12px 0px #383f4d1a";
export const onLightShadowLg = "0px 16px 32px 0px #383f4d26";
export const onLightDividerEmphasis = "#282d3799";
export const onLightDividerMuted = "#282d3733";
export const onLightSkeletonEmphasis = "#282d370f";
export const onLightSkeletonMuted = "#282d370d";
export const onLightDisabledFlat = "#F6F8FB";
export const onLightDisabledMuted = "#CACCD6";
export const space0 = "0px";
export const space100 = "8px";
export const space150 = "12px";
export const space200 = "16px";
export const space250 = "20px";
export const space300 = "24px";
export const space350 = "28px";
export const space400 = "32px";
export const space600 = "48px";
export const space800 = "64px";
export const space1000 = "80px";
export const space1200 = "96px";
export const space1400 = "112px";
export const space1600 = "128px";
export const space025 = "2px";
export const space050 = "4px";
export const space075 = "6px";
export const onDarkSurfacePrimary = "#282D37";
export const onDarkSurfaceSecondary = "#12151A";
export const onDarkSurfaceActive = "#383F4D";
export const onDarkTextPrimary = "#ffffff";
export const onDarkTextSecondary = "#EEF0F5";
export const onDarkTextTertiary = "#979CB0";
export const onDarkTextLink = "#7ED8FF";
export const onDarkBorderSubtle = "#eef0f51a";
export const onDarkBorderEmphasis = "#eef0f580";
export const onDarkBorderActive = "#7ED8FF";
export const onDarkBorderActionPrimaryFallback = "transparent";
export const onDarkIconPrimary = "#ffffff";
export const onDarkIconSecondary = "#979CB0";
export const onDarkOverlay = "#282d37bf";
export const onDarkDividerEmphasis = "#ffffff99";
export const onDarkDividerMuted = "#ffffff26";
export const onDarkSkeletonEmphasis = "#ffffff4d";
export const onDarkSkeletonMuted = "#ffffff26";
export const onDarkDisabledMuted = "#666E7D";
export const onDarkDisabledFlat = "#383F4D";
export const actionPrimaryLightest = "#F2FBFF";
export const actionPrimaryLight = "#DEF5FF";
export const actionPrimaryBase = "#7ED8FF";
export const actionPrimaryDark = "#2A4ECC";
export const actionPrimaryDarkest = "#1336B2";
export const actionPrimarySafeOnLight = "#2A4ECC";
export const actionPrimarySafeOnDark = "#7ED8FF";
export const actionNeutralLightest = "#F6F8FB";
export const actionNeutralLight = "#EEF0F5";
export const actionNeutralBase = "#666E7D";
export const actionNeutralDark = "#383F4D";
export const actionNeutralDarkest = "#282D37";
export const actionDestructiveLightest = "#FFF4F2";
export const actionDestructiveLight = "#FFE3E0";
export const actionDestructiveBase = "#FFBCB5";
export const actionDestructiveDark = "#CC2414";
export const actionDestructiveDarkest = "#A31C0F";
export const actionWarningLightest = "#FDFFE5";
export const actionWarningLight = "#FBFDB6";
export const actionWarningBase = "#F4943A";
export const actionWarningDark = "#CC491A";
export const actionWarningDarkest = "#B63D01";
export const actionPositiveLightest = "#F2FFFA";
export const actionPositiveLight = "#E1F7F2";
export const actionPositiveBase = "#A4FFD9";
export const actionPositiveDark = "#14806F";
export const actionPositiveDarkest = "#056152";
export const actionUpsellLightest = "#F9F5FF";
export const actionUpsellLight = "#EEE9F7";
export const actionUpsellBase = "#B7ACCA";
export const actionUpsellDark = "#6A578B";
export const actionUpsellDarkest = "#574573";
export const actionAiLightest = "#FFF5FA";
export const actionAiLight = "#FFEBF5";
export const actionAiBase = "#FFA0D2";
export const actionAiDark = "#FF4AA9";
export const actionAiDarkest = "#A60358";
export const actionAiMulticolored =
  "linear-gradient(61deg, #2A4ECC 2.46%, #DA0B78 42.73%, #FF4AA9 103.12%)";
export const onActionPrimaryLightest = "#2A4ECC";
export const onActionPrimaryLight = "#1336B2";
export const onActionPrimaryBase = "#1336B2";
export const onActionPrimaryDark = "#F2FBFF";
export const onActionPrimaryDarkest = "#DEF5FF";
export const onActionPrimarySafeOnLight = "#F2FBFF";
export const onActionPrimarySafeOnDark = "#1336B2";
export const webDisplayXsFontFamily = "Poppins, Helvetica, sans-serif";
export const webDisplayXsFontWeight = 600;
export const webDisplayXsFontSize = "1.125rem";
export const webDisplayXsLineHeight = "1.75rem";
export const webDisplayXsLetterSpacing = "0rem";
export const webDisplaySmFontFamily = "Poppins, Helvetica, sans-serif";
export const webDisplaySmFontWeight = 600;
export const webDisplaySmLineHeight = "1.75rem";
export const webDisplaySmFontSize = "1.25rem";
export const webDisplaySmLetterSpacing = "0rem";
export const webDisplayBaseFontFamily = "Poppins, Helvetica, sans-serif";
export const webDisplayBaseFontWeight = 600;
export const webDisplayBaseLineHeight = "2rem";
export const webDisplayBaseFontSize = "1.5rem";
export const webDisplayBaseLetterSpacing = "0rem";
export const webDisplayMdFontFamily = "Poppins, Helvetica, sans-serif";
export const webDisplayMdFontWeight = 400;
export const webDisplayMdLineHeight = "2.5rem";
export const webDisplayMdFontSize = "2rem";
export const webDisplayMdLetterSpacing = "-0.02rem";
export const webDisplayLgFontFamily = "Poppins, Helvetica, sans-serif";
export const webDisplayLgFontWeight = 400;
export const webDisplayLgLineHeight = "3rem";
export const webDisplayLgFontSize = "2.5rem";
export const webDisplayLgLetterSpacing = "-0.02rem";
export const webDisplayXlFontFamily = "Poppins, Helvetica, sans-serif";
export const webDisplayXlFontWeight = 400;
export const webDisplayXlLineHeight = "4rem";
export const webDisplayXlFontSize = "3.25rem";
export const webDisplayXlLetterSpacing = "-0.04rem";
export const webBodyXsFontFamily = "Inter, Helvetica, sans-serif";
export const webBodyXsFontWeight = 400;
export const webBodyXsLineHeight = "1rem";
export const webBodyXsFontSize = "0.75rem";
export const webBodySmFontFamily = "Inter, Helvetica, sans-serif";
export const webBodySmFontWeight = 400;
export const webBodySmLineHeight = "1.25rem";
export const webBodySmFontSize = "0.875rem";
export const webBodyBaseFontFamily = "Inter, Helvetica, sans-serif";
export const webBodyBaseFontWeight = 400;
export const webBodyBaseLineHeight = "1.5rem";
export const webBodyBaseFontSize = "1rem";
export const webBodyMdFontFamily = "Inter, Helvetica, sans-serif";
export const webBodyMdFontWeight = 600;
export const webBodyMdLineHeight = "1.5rem";
export const webBodyMdFontSize = "1rem";
export const webBodyLgFontFamily = "Inter, Helvetica, sans-serif";
export const webBodyLgFontWeight = 400;
export const webBodyLgLineHeight = "1.75rem";
export const webBodyLgFontSize = "1.25rem";
export const webBodyXlFontFamily = "Inter, Helvetica, sans-serif";
export const webBodyXlFontWeight = 600;
export const webBodyXlLineHeight = "1.75rem";
export const webBodyXlFontSize = "1.25rem";
export const mobileDisplayXsFontFamily = "Poppins, Helvetica, sans-serif";
export const mobileDisplayXsFontWeight = 600;
export const mobileDisplayXsFontSize = "1rem";
export const mobileDisplayXsLineHeight = "1.5rem";
export const mobileDisplayXsLetterSpacing = "0rem";
export const mobileDisplaySmFontFamily = "Poppins, Helvetica, sans-serif";
export const mobileDisplaySmFontWeight = 600;
export const mobileDisplaySmLineHeight = "1.5rem";
export const mobileDisplaySmFontSize = "1rem";
export const mobileDisplaySmLetterSpacing = "0rem";
export const mobileDisplayBaseFontFamily = "Poppins, Helvetica, sans-serif";
export const mobileDisplayBaseFontWeight = 600;
export const mobileDisplayBaseLineHeight = "1.75rem";
export const mobileDisplayBaseFontSize = "1.25rem";
export const mobileDisplayBaseLetterSpacing = "0rem";
export const mobileDisplayMdFontFamily = "Poppins, Helvetica, sans-serif";
export const mobileDisplayMdFontWeight = 400;
export const mobileDisplayMdLineHeight = "2rem";
export const mobileDisplayMdFontSize = "1.5rem";
export const mobileDisplayMdLetterSpacing = "-0.02rem";
export const mobileDisplayLgFontFamily = "Poppins, Helvetica, sans-serif";
export const mobileDisplayLgFontWeight = 400;
export const mobileDisplayLgLineHeight = "2.25rem";
export const mobileDisplayLgFontSize = "1.75rem";
export const mobileDisplayLgLetterSpacing = "-0.02rem";
export const mobileDisplayXlFontFamily = "Poppins, Helvetica, sans-serif";
export const mobileDisplayXlFontWeight = 400;
export const mobileDisplayXlLineHeight = "2.5rem";
export const mobileDisplayXlFontSize = "2rem";
export const mobileDisplayXlLetterSpacing = "-0.02rem";
export const mobileBodyXsFontFamily = "Inter, Helvetica, sans-serif";
export const mobileBodyXsFontWeight = 400;
export const mobileBodyXsLineHeight = "1rem";
export const mobileBodyXsFontSize = "0.625rem";
export const mobileBodySmFontFamily = "Inter, Helvetica, sans-serif";
export const mobileBodySmFontWeight = 400;
export const mobileBodySmLineHeight = "1.25rem";
export const mobileBodySmFontSize = "0.75rem";
export const mobileBodyBaseFontFamily = "Inter, Helvetica, sans-serif";
export const mobileBodyBaseFontWeight = 400;
export const mobileBodyBaseLineHeight = "1.25rem";
export const mobileBodyBaseFontSize = "0.875rem";
export const mobileBodyMdFontFamily = "Inter, Helvetica, sans-serif";
export const mobileBodyMdFontWeight = 600;
export const mobileBodyMdLineHeight = "1.25rem";
export const mobileBodyMdFontSize = "0.875rem";
export const mobileBodyLgFontFamily = "Inter, Helvetica, sans-serif";
export const mobileBodyLgFontWeight = 400;
export const mobileBodyLgLineHeight = "1.5rem";
export const mobileBodyLgFontSize = "1.125rem";
export const mobileBodyXlFontFamily = "Inter, Helvetica, sans-serif";
export const mobileBodyXlFontWeight = 600;
export const mobileBodyXlLineHeight = "1.5rem";
export const mobileBodyXlFontSize = "1.125rem";
export const brandBlue100 = "#F2FBFF";
export const brandBlue300 = "#DEF5FF";
export const brandBlue500 = "#7ED8FF";
export const brandBlue700 = "#2A4ECC";
export const brandBlue900 = "#1336B2";
export const brandBlueBright = "#DEF5FF";
export const brandBlueBase = "#7ED8FF";
export const brandBlueDim = "#3561FF";
export const brandBlueGradientDim =
  "linear-gradient(45deg, #3561FF 0%, #7ED8FF 100%)";
export const brandBlueGradientBright =
  "linear-gradient(45deg, #DEF5FF 0%, #FFFFFF 100%)";
export const brandYellow100 = "#FDFFE5";
export const brandYellow300 = "#FBFDB6";
export const brandYellow500 = "#F5FF85";
export const brandYellow700 = "#F4943A";
export const brandYellow900 = "#994D07";
export const brandYellowGradientDim =
  "linear-gradient(45deg, #FFB546 0%, #F5FF85 100%)";
export const brandYellowGradientBright =
  "linear-gradient(45deg, #F9FFB7 0%, #FFFFFF 100%)";
export const brandTurquoise100 = "#F2FFFA";
export const brandTurquoise300 = "#E1F7F2";
export const brandTurquoise500 = "#A4FFD9";
export const brandTurquoise700 = "#14806F";
export const brandTurquoise900 = "#056152";
export const brandTurquoiseBright = "#A4FFD9";
export const brandTurquoiseBase = "#248C7D";
export const brandTurquoiseDim = "#0A6658";
export const brandTurquoiseGradientDim =
  "linear-gradient(45deg, #248C7D 0%, #A4FFD9 100%)";
export const brandTurquoiseGradientBright =
  "linear-gradient(45deg, #CFFFEE 0%, #FFFFFF 100%)";
export const brandPink100 = "#FFF5FA";
export const brandPink300 = "#FFCCE5";
export const brandPink500 = "#FFA0D2";
export const brandPink700 = "#FF4AA9";
export const brandPink900 = "#A60358";
export const brandPinkBright = "#FFC6E4";
export const brandPinkBase = "#FFA0D2";
export const brandPinkDim = "#FF4AA9";
export const brandPinkGradientDim =
  "linear-gradient(45deg, #FF4AA9 0%, #FFC6E4 100%)";
export const brandPinkGradientBright =
  "linear-gradient(45deg, #FFE0F0 0%, #FFFFFF 100%)";
export const brandMauve100 = "#F9F5FF";
export const brandMauve300 = "#EEE9F7";
export const brandMauve500 = "#B7ACCA";
export const brandMauve700 = "#6A578B";
export const brandMauve900 = "#574573";
export const brandMauveBright = "#E6D8FF";
export const brandMauveBase = "#B7ACCA";
export const brandMauveDim = "#9C85C5";
export const brandMauveGradientDim =
  "linear-gradient(45deg, #9C85C5 0%, #E6D8FF 100%)";
export const brandMauveGradientBright =
  "linear-gradient(45deg, #F0E8FF 0%, #FFFFFF 100%)";
export const brandOrange100 = "#FFF6F2";
export const brandOrange300 = "#FFECE5";
export const brandOrange500 = "#FD612A";
export const brandOrange700 = "#CC491A";
export const brandOrange900 = "#B63D01";
export const brandOrangeBright = "#F5FF85";
export const brandOrangeBase = "#FFB546";
export const brandOrangeDim = "#FD612A";
export const brandOrangeGradientDim =
  "linear-gradient(45deg, #FD612A 0%, #FFB546 100%)";
export const brandOrangeGradientBright =
  "linear-gradient(45deg, #FFB546 0%, #FFFFFF 100%)";
export const brandPlusOffWhite = "#FFFDFA";
export const brandPlusBlack = "#000821";
export const brandPlusPrimaryBlue = "#3561FF";
export const brandPlusSecondaryBlue = "#7EE5FF";
export const brandPlusGradient =
  "linear-gradient(45deg, #3561FF 0%, #7EE5FF 100%)";
export const labelXsFontFamily = "Inter, Helvetica, sans-serif";
export const labelXsFontWeight = 600;
export const labelXsFontSize = "0.75rem";
export const labelXsLineHeight = "1rem";
export const labelSmFontFamily = "Inter, Helvetica, sans-serif";
export const labelSmFontWeight = 600;
export const labelSmLineHeight = "1.5rem";
export const labelSmFontSize = "0.875rem";
export const labelMdFontFamily = "Inter, Helvetica, sans-serif";
export const labelMdFontWeight = 600;
export const labelMdLineHeight = "1.5rem";
export const labelMdFontSize = "1rem";
export const labelLgFontFamily = "Inter, Helvetica, sans-serif";
export const labelLgFontWeight = 600;
export const labelLgLineHeight = "2rem";
export const labelLgFontSize = "1.5rem";
export const radiusSm = "4px";
export const radiusMd = "8px";
export const radiusLg = "12px";
export const radiusFull = 99999;
export const codeXsFontFamily = "'Source Code Pro', Courier New, monospace";
export const codeXsFontWeight = 400;
export const codeXsLineHeight = "1rem";
export const codeXsFontSize = "0.75rem";
export const codeSmFontFamily = "'Source Code Pro', Courier New, monospace";
export const codeSmFontWeight = 400;
export const codeSmLineHeight = "1.25rem";
export const codeSmFontSize = "0.875rem";
export const codeBaseFontFamily = "'Source Code Pro', Courier New, monospace";
export const codeBaseFontWeight = 400;
export const codeBaseLineHeight = "1.5rem";
export const codeBaseFontSize = "1rem";
export const light = "0.5px";
export const regular = "1px";
export const medium = "1.5px";
export const bold = "2px";
export const helpTextXsFontFamily = "Inter, Helvetica, sans-serif";
export const helpTextXsFontWeight = 400;
export const helpTextXsLineHeight = "1rem";
export const helpTextXsFontSize = "0.75rem";
export const helpTextSmFontFamily = "Inter, Helvetica, sans-serif";
export const helpTextSmFontWeight = 400;
export const helpTextSmLineHeight = "1.25rem";
export const helpTextSmFontSize = "0.875rem";
export const helpTextMdFontFamily = "Inter, Helvetica, sans-serif";
export const helpTextMdFontWeight = 400;
export const helpTextMdLineHeight = "1.5rem";
export const helpTextMdFontSize = "1rem";
export const helpTextLgFontFamily = "Inter, Helvetica, sans-serif";
export const helpTextLgFontWeight = 400;
export const helpTextLgLineHeight = "2rem";
export const helpTextLgFontSize = "1.5rem";
export const breakpointsSm = "320px";
export const breakpointsMd = "768px";
export const breakpointsLg = "1024px";
export const breakpointsXl = "1280px";
export const zIndexBelow = -1;
export const zIndexBase = 0;
export const zIndexAbove = 1;
export const zIndexPortal = 2147483647;
